import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import moment from 'moment'

pdfMake.vfs = pdfFonts.pdfMake.vfs

// ── Helpers ───────────────────────────────────────────────────────────────────

const formatName = (nama) => {
  if (!nama) return null
  if (nama.length <= 30) {
    return nama.split(' ').filter(Boolean).map((w) => w[0].toUpperCase() + w.slice(1)).join(' ')
  }
  return (
    nama.slice(0, 29).split(' ').filter(Boolean).map((w) => w[0].toUpperCase() + w.slice(1)).join(' ') + '.'
  )
}

const buildApprovalHeader = (label, colSpan = 1) => ({
  text:      label,
  bold:      true,
  alignment: 'center',
  fontSize:  7,
  border:    [true, true, true, true],
  fillColor: '#f2f2f2',
  margin:    [2, 3, 2, 3],
  colSpan,
})

const buildApprovalBody = (item) => {
  const border = [true, true, true, true]

  if (!item) {
    return {
      stack:  [{ text: '\n\n-\n\n-', alignment: 'center', fontSize: 7 }],
      border,
      margin: [2, 8, 2, 8],
    }
  }

  const name    = formatName(item.nama)
  const jabatan = item.jabatan === null
    ? '-'
    : item.jabatan === 'area'
      ? 'AOS'
      : item.jabatan.toUpperCase()
  const date    = moment(item.updatedAt).format('DD/MM/YYYY')
  const status  = item.status === 0 ? `Reject (${date})` : item.status === 1 ? `Approve (${date})` : ''

  return {
    stack: [
      { text: status,      alignment: 'center', fontSize: 6, margin: [0, 6, 0, 0] },
      { text: '\n' },
      { text: name || '-', alignment: 'center', fontSize: 7 },
      { text: jabatan,     alignment: 'center', fontSize: 6 },
    ],
    border,
    margin: [2, 8, 2, 8],
  }
}

// ─────────────────────────────────────────────────────────────────────────────

class FormStockPdf extends Component {

  downloadForm = async () => {
    this.setState({ isLoading: true })

    const { detailStock, stockApp } = this.props.stock
    const dataApp = stockApp

    // ── Info header ───────────────────────────────────────────────────────────
    const firstDetail   = detailStock?.[0] || {}
    const area          = firstDetail.area ? firstDetail.area.toUpperCase() : ''
    const tanggalStock  = firstDetail.tanggalStock
      ? moment(firstDetail.tanggalStock).format('DD MMMM YYYY')
      : ''
    const noStock       = firstDetail.no_stock || ''

    // ── Tabel item header ─────────────────────────────────────────────────────
    // Kolom: No | No.Aset | Deskripsi | Merk | Satuan | Unit | Status Fisik | Kondisi | Lokasi | Grouping | Keterangan | Status Clear
    const tableHeader = [
      { text: 'NO',           bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      { text: 'NO. ASET',     bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      { text: 'DESKRIPSI',    bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      { text: 'MERK',         bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      { text: 'SATUAN',       bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      { text: 'UNIT',         bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      { text: 'STATUS FISIK', bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      { text: 'KONDISI',      bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      { text: 'LOKASI',       bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      { text: 'GROUPING',     bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
      { text: 'KETERANGAN',   bold: true, alignment: 'center', fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7 },
    ]

    const tableRows = (detailStock || []).map((item, index) => [
      { text: String(index + 1),       alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: item.no_asset    || '',  alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: item.deskripsi   || '',  alignment: 'left',   border: [true,true,true,true], fontSize: 7 },
      { text: item.merk        || '',  alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: item.satuan      || '',  alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: item.unit        || '',  alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: item.status_fisik|| '',  alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: item.kondisi     || '',  alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: item.lokasi      || '',  alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: item.grouping    || '',  alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: item.keterangan  || '',  alignment: 'left',   border: [true,true,true,true], fontSize: 7 },
    ])

    // ── Approval lists ────────────────────────────────────────────────────────
    const buatList    = dataApp?.pembuat   ? [...dataApp.pembuat]   : []
    const periksaList = dataApp?.pemeriksa ? [...dataApp.pemeriksa] : []
    const setujuList  = dataApp?.penyetuju ? [...dataApp.penyetuju] : []

    if (!buatList.length)    buatList.push(null)
    if (!periksaList.length) periksaList.push(null)
    if (!setujuList.length)  setujuList.push(null)

    const totalCols      = buatList.length + periksaList.length + setujuList.length
    const approvalWidths = Array(totalCols).fill('*')

    const approvalHeaderRow = [
      { ...buildApprovalHeader('Dibuat oleh,', buatList.length) },
      ...Array(buatList.length - 1).fill({ text: '', border: [false,false,false,false] }),
      { ...buildApprovalHeader('Diperiksa oleh,', periksaList.length) },
      ...Array(periksaList.length - 1).fill({ text: '', border: [false,false,false,false] }),
      { ...buildApprovalHeader('Disetujui oleh,', setujuList.length) },
      ...Array(setujuList.length - 1).fill({ text: '', border: [false,false,false,false] }),
    ]

    const approvalBodyRow = [
      ...buatList.map((item)    => buildApprovalBody(item)),
      ...periksaList.map((item) => buildApprovalBody(item)),
      ...setujuList.map((item)  => buildApprovalBody(item)),
    ]

    // ── Doc definition ────────────────────────────────────────────────────────
    // pdfmake handle pagination otomatis, tidak perlu logic firstPageLimit/nextPageLimit
    const docDefinition = {
      pageSize:        'A4',
      pageOrientation: 'landscape',
      pageMargins:     [25, 25, 25, 30],

      footer: (currentPage, pageCount) => ({
        text:      `Halaman ${currentPage} dari ${pageCount}`,
        alignment: 'center',
        fontSize:  7,
        margin:    [0, 8, 0, 0],
      }),

      content: [

        // ── Judul ─────────────────────────────────────────────────────────────
        { text: 'KERTAS KERJA OPNAME ASET', bold: true, fontSize: 12, margin: [0, 0, 0, 6] },

        // ── Info header ───────────────────────────────────────────────────────
        { text: 'PT. PINUS MERAH ABADI', bold: true, fontSize: 11, margin: [0, 0, 0, 6] },
        {
          columns: [
            { text: 'KANTOR PUSAT/CABANG', bold: true, fontSize: 9, width: 130 },
            { text: `: ${area}`,           bold: true, fontSize: 9 },
          ],
          margin: [0, 0, 0, 4],
        },
        {
          columns: [
            { text: 'DEPO/CP',             bold: true, fontSize: 9, width: 130 },
            { text: `: ${area}`,           bold: true, fontSize: 9 },
          ],
          margin: [0, 0, 0, 4],
        },
        {
          columns: [
            { text: 'OPNAME PER TANGGAL',  bold: true, fontSize: 9, width: 130 },
            { text: `: ${tanggalStock}`,   bold: true, fontSize: 9 },
          ],
          margin: [0, 0, 0, 10],
        },

        // ── Tabel Data ────────────────────────────────────────────────────────
        // pdfmake otomatis lanjut ke halaman berikutnya kalau penuh
        {
          table: {
            headerRows: 1, // header diulang tiap halaman otomatis
            widths:     ['auto', 60, '*', 35, 25, 20, 35, 30, 40, 35, '*'],
            body:       [tableHeader, ...tableRows],
          },
          layout: {
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5,
          },
          margin: [0, 0, 0, 14],
        },

        // ── Tabel Approval ────────────────────────────────────────────────────
        {
          table: {
            widths: approvalWidths,
            body:   [approvalHeaderRow, approvalBodyRow],
          },
          layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5 },
        },
      ],

      defaultStyle: {
        fontSize: 8,
        font:     'Roboto',
      },
    }

    const fileName = `Form Stock Opname Asset ${noStock} ${moment().format('DD MMMM YYYY')}.pdf`

    return new Promise((resolve, reject) => {
      try {
        pdfMake.createPdf(docDefinition).download(fileName, () => {
          this.setState({ isLoading: false })
          resolve(fileName)
        })
      } catch (err) {
        this.setState({ isLoading: false })
        reject(err)
      }
    })
  }

  render() {
    return (
      <Button
        color="success"
        onClick={this.downloadForm}
        className='mr-2'
      >
        Download Form PDF
      </Button>
    )
  }
}

const mapStateToProps = (state) => ({
  asset:    state.asset,
  depo:     state.depo,
  stock:    state.stock,
  user:     state.user,
  tempmail: state.tempmail,
  newnotif: state.newnotif,
  dokumen:  state.dokumen,
})

export default connect(mapStateToProps)(FormStockPdf)